import { useMutation } from "@tanstack/react-query";

import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import apiClient from "@app/common/api/apiClient";

/**
 * Generic hook for creating a setup intent to pass to StripeElements.
 *
 * Should only be used in cases where we are collecting payment info but
 * charges will not be immediate (e.g. updating payment info, purchasing a
 * subscription with a free trial).
 *
 * DO NOT USE in the checkout flow or any flow where the customer will be charged
 * upon form submit.
 * */
const useSetupIntent = () => {
  const { billingAccount } = useBillingContext();

  const createSetupIntentMutation = useMutation({
    mutationFn: (opts: { promotionId?: string }) => {
      if (!billingAccount?.id) throw new Error("No billing account");
      return apiClient.billing.createSetupIntent(
        billingAccount.id,
        opts.promotionId
      );
    },
  });

  return {
    createSetupIntent: createSetupIntentMutation,
  };
};

export default useSetupIntent;
